import React from 'react';
export function Footer() {
  return <footer className="w-full py-6 bg-gray-900 text-white" data-id="element-53">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-54">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-55">
          <div className="flex items-center gap-2 mb-4 md:mb-0" data-id="element-56">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jD76Ad18n41rEXtZp1ThPL/focusflow_logo.png" alt="FocusFlow Logo" className="h-14" data-id="element-57" />
          </div>
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-58">
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-59">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-60">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-61">
              Contact Us
            </a>
          </div>
        </div>
        <div className="mt-6 text-center text-sm text-gray-400" data-id="element-62">
          <p data-id="element-63">© 2023 FocusFlow. All rights reserved.</p>
          <p className="mt-1" data-id="element-64">
            Results may vary. These statements have not been evaluated by the
            FDA.
          </p>
        </div>
      </div>
    </footer>;
}